import classNames from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import DataItem from 'components/DataItem';
import DefaultActionButtons from 'components/DefaultActionButtons';
import Text from 'components/typography/Text';
import {
  showSuccessFeedbackBar,
  showErrorFeedbackBar,
} from 'reducers/ui/uiSlice';
import { deleteClientApi } from 'services/ClientService';
import {
  BUTTON_TYPE_BUTTON,
  BUTTON_TYPE_SUBMIT,
} from 'shared/constants/common';
import { getFullname, displayDate } from 'shared/helpers/common';
import PassportModal from './PassportModal';

export default function PassportItem({
  onPassportUpdate,
  onPassportDelete,
  formDropdownConfig,
  data = {},
}) {
  const dispatch = useDispatch();
  const [isEditModalOpen, setEditModalState] = useState(false);

  const {
    passportNumber = '',
    citizenship = '',
    dateOfBirth = '',
    passportExpiry = '',
    name: { first: firstName = '', last: lastName = '' } = {},
  } = data;

  const onPassportUpdateHandler = (id, updatedData) => {
    onPassportUpdate?.(id, updatedData);
  };

  const onDelete = async () => {
    try {
      await deleteClientApi(data?.id);
      onPassportDelete?.(data?.id);
      dispatch(showSuccessFeedbackBar('Passport successfully deleted.'));
    } catch (error) {
      console.error(error);
      dispatch(
        showErrorFeedbackBar(
          'Something went wrong. Failed to delete passport.',
        ),
      );
    }
  };

  return (
    <>
      <div className="w-full">
        <div className="rounded-[10px] overflow-hidden">
          <div className={classNames('bg-white rounded-t-lg p-2 lg:p-[25px] pb-0')}>
            <Text className="font-medium text-[22px] mb-2">
              {getFullname({ firstName, lastName })}
            </Text>

            <div className="flex flex-wrap w-full text-[16px] leading-[20px]">
              <DataItem label="Passport number" value={passportNumber} isHalf />
              <DataItem label="Citizenship" value={citizenship} isHalf />
              <DataItem
                label="Date of birth"
                value={displayDate(dateOfBirth, '-', undefined, true)}
                isHalf
              />
              <DataItem
                label="Passport expiry date"
                value={displayDate(passportExpiry, '-', undefined, true)}
                isHalf
              />
            </div>
          </div>
          <div>
            <DefaultActionButtons
              onSecondaryButtonClick={onDelete}
              onPrimaryButtonClick={() => setEditModalState(true)}
              secondaryButtonLabel="Delete"
              primaryButtonLabel="View / Edit"
              containerClassName="border-t p-4 bg-white rounded-b-lg"
              secondaryButtonClassName="px-4"
              primaryButtonClassName="px-4"
              primaryButtonType={BUTTON_TYPE_BUTTON}
              secondaryButtonType={BUTTON_TYPE_SUBMIT}
            />
          </div>
        </div>
      </div>
      <PassportModal
        isOpen={isEditModalOpen}
        setModalState={setEditModalState}
        data={data}
        fullname={getFullname({ firstName, lastName })}
        onPassportUpdate={onPassportUpdateHandler}
        formDropdownConfig={formDropdownConfig}
        passportType="client"
      />
    </>
  );
}
